import Styles from './StrategicRecommendations.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Spinner } from 'common/Spinner/Spinner'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { StrategicRecommendation } from 'types'

export interface RecommendationProps {
  isGenerating: boolean
  recommendations?: StrategicRecommendation[]
  title: string
  icon: string
}

export const Recommendation = ({ isGenerating, recommendations, title, icon }: RecommendationProps) => {
  return (
    <div className={Styles.categoryContainer}>
      <div className={Styles.categoryHeader}>
        <div className={Styles.categoryIcon}>{icon}</div>
        <Heading level={4}>{title}</Heading>
      </div>
      {isGenerating || !recommendations?.length ? (
        <div className={Styles.loading}>
          {isGenerating ? (
            <>
              <div className={Styles.loadingWrapper}>
                <div className={Styles.loadingLabel}>
                  <Spinner />
                  <Text variant="primary" color="var(--dark-90)">
                    Analyzing your data
                  </Text>
                </div>
              </div>
              <LoadingEllipses />
            </>
          ) : (
            <div className={Styles.loadingLabel}>
              <Text variant="primary" color="var(--dark-90)">
                We couldn't generate any recommendations for this account.
              </Text>
            </div>
          )}
        </div>
      ) : (
        <>
          {recommendations?.map(({ recommendation, reasoning }, index) => (
            <div className={Styles.categoryContent} key={`topic-recommendation-${index}`}>
              <div className={Styles.categoryColumn}>
                <Heading level={5}>Recommendation</Heading>
                <Text variant="primary" color="var(--dark-60)">
                  {recommendation}
                </Text>
              </div>
              <div className={Styles.categoryColumn}>
                <Heading level={5}>Why this works</Heading>
                <Text variant="primary" color="var(--dark-60)">
                  {reasoning}
                </Text>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  )
}
